import React, { Component } from 'react';
import Button from 'components/Button/Button';

export default class VacancyGridItem extends Component {
  render() {
    const vacancyImage = this.props.vacancyImage;
    const vacancyTitle = this.props.vacancyTitle;
    const vacancyHref = this.props.vacancyHref;
    const vacancySubText = this.props.vacancySubText;
    var divStyle = {
      backgroundImage: 'url(' + vacancyImage + ')',
    };
    return (
      <Button className="btn vacancyGridItem" to={`/vacatures/${vacancyHref}`} delay={true}>
        {vacancyImage && (<div className="vacancy-item__image" style={divStyle} alt={vacancyImage}></div>)}
        {vacancyTitle && <h4>{vacancyTitle}</h4>}
        {vacancySubText && <p>{vacancySubText}</p>}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Vacancy/VacancyGrid/VacancyGridItem.jsx